'use client';
import { atom, useAtom } from 'jotai';

const paymentSuccessAtom = atom<boolean>(false);

export const usePaymentSuccess = () => {
  const [isPaymentSuccess, setIsPaymentSuccess] = useAtom(paymentSuccessAtom);

  return {
    isPaymentSuccess,
    markPaymentSuccess: () => setIsPaymentSuccess(true),
    clearPaymentSuccess: () => setIsPaymentSuccess(false),
  };
};
